<ng-container *ngIf="phase">
    <actions class="no-booking" [actionstrip]="actions" (clickAction)="onClickAction($event)" *ngIf="!readonly">
    </actions>

    <div class="info-phase">
        <div class="line first-line">
            <div class="part-esquerra">
                <a class="button-icon-marker marker  no-booking" (click)="onMarkerClick()"><i
                        class="fa fa-map-marker"></i></a>
                <div class="square-tag color generalstatus" [ngClass]="phase.generalStatus"><span
                        class="internalGeneralStatus">{{generalStatusResource | translate}}</span></div>
                <div class="square-tag executionorder first">
                    {{phase.executionOrder+1}}
                </div>
                <div class="square-tag load" *ngIf="phase.isLoad">
                    <i class="hardman-routetype-outbound iconaInboundReturnNonacceptance"></i>
                    {{'PHASE.ISLOAD'| translate}}
                </div>
                <div class="square-tag unload" *ngIf="phase.isUnload">
                    <i class="hardman-routetype-inbound iconaInboundReturnNonacceptance"></i>
                    {{'PHASE.ISUNLOAD'| translate}}
                </div>
                <div class="square-tag unloadload" *ngIf="phase.isUnloadLoad">
                    <i class="hardman-routetype-delegate iconaInboundReturnNonacceptance"></i>
                    {{'PHASE.ISUNLOADLOAD'| translate}}
                </div>
                <shared-tags-strip-component class="square"
                    [uniqueString]="phase.strongAddressSkin"></shared-tags-strip-component>
                <shared-tags-strip-component class="square"
                    [uniqueString]="phase.addressKey"></shared-tags-strip-component>
                <div class="square-tag disponibilityMessage">
                    <i class="fa fa-clock-o" aria-hidden="true"></i> {{phase.disponibilityMessage}}
                </div>
            </div>
            <div class="contenidor-slots">
                <shared-slot-viewer-component *ngIf="phase.requiresSlot && phase.slotInfo" class="relative showDock"
                    [exwork]="exwork" [slotInfo]="phase.slotInfo" [phaseId]="phase.phaseId"
                    (callBack)="onRefreshRoute($event)" [readonly]="readonly">
                </shared-slot-viewer-component>
                <div class="dummy-actions"></div>
            </div>
        </div>
        <div class="line address">
            <shared-tags-strip-component *ngIf="phase.showStrongAddress" class="tags"
                [uniqueString]="phase.strongAddressSkin" [applyColor]=false></shared-tags-strip-component>
            <shared-copyclipboard [value]="phase.formattedAddress"><span
                    class="formatted-address">{{phase.formattedAddress}}</span></shared-copyclipboard>

        </div>

        <shared-tags-strip-component class="line tags tags-docks" [tags]="phase.userTags"
            [applyColor]=false></shared-tags-strip-component>
        <div class="docks line">
            <div *ngFor="let dock of (phase.docksEnabled ? phase.docksEnabled : [])" class="enabled-dock">{{
                dock }}
            </div>
        </div>

        <div class="line goods">
            {{phase.goods}}
        </div>
        <div class="line verificationCode" *ngIf="phase.verificationCode && !exwork">
            <shared-secret [iPhaseSlot]="phase"></shared-secret>
        </div>
        <div class="line only-hardman-user ">
            phaseId: <shared-copyclipboard [value]="phase.phaseId">{{phase.phaseId}}</shared-copyclipboard>
        </div>

        <button class="line link right no-booking"
            *ngIf="!phase.isSlotBlocked && phase.canSetSlot && !hideLink && !readonly" (click)="getSlots()">{{
            getSlotPickerResource() | translate}}</button>

    </div>
    <shared-slot-picker *ngIf="intervals && phase.requiresSlot && phase.canSetSlot" class="relative activeslots"
        [avoidPropertyPendingResponse]="avoidPropertyPendingResponse" [phase]="phase" [hideTitle]="true"
        [canviSlot]="true" (valueChange)="onRefreshRoute($event)" (callBack)="onRefreshRoute($event)"
        [readonly]="readonly"></shared-slot-picker>

</ng-container>